import { Tooltip } from '@bryntum/schedulerpro';
import { useEffect } from 'react';
import { fullName } from 'utils/full-name';
import { SchedulerReference } from '../../types';
import { timeoffTooltip } from '../templates/timeoff-template';

export const useTimeoffTooltip = (ref: SchedulerReference): void => {
  useEffect(() => {
    const tooltip = new Tooltip({
      forSelector:
        '.b-sch-event.user_allocation_summary.time-off-user > .b-sch-event-content > .time-off-icon',
      maxWidth: 312,
      getHtml: (params) => {
        const { event } = params;
        const eventId = (
          event.target.querySelector('.time-off-icon') ??
          event.target.closest('.time-off-icon') ??
          event.target
        )?.getAttribute('data-event-id');

        const allocationEvent =
          ref.current?.instance.eventStore.getById(eventId);

        if (allocationEvent) {
          const resource = ref.current?.instance.resourceStore.getById(
            allocationEvent.resourceId,
          );

          const timeOff = allocationEvent.get('timeOff');

          const firstName = resource.get('firstName');
          const lastName = resource.get('lastName');

          return timeoffTooltip({
            userName: fullName({
              firstName,
              lastName,
            }),
            timeOff,
          });
        }

        return null;
      },
      hoverDelay: 800,
      hideDelay: 100,
      constrainTo: ref.current.instance.timeAxisSubGridElement,
    });

    return () => {
      tooltip.destroy();
    };
  }, [ref]);
};
